import styled from 'styled-components';

import { breakpoint } from 'DesignLibrary/global';

export const MarketingCarouselContainer = styled.section`
  width: 115%;
  margin-bottom: 5rem;

  ${breakpoint.TABLET} {
    width: 120vw;
    transform: translateX(-50%);
    margin-bottom: 7rem;
    left: 50%;
    position: relative;
  }

  .react-multi-carousel-track {
    li {
      padding-right: 3rem;
      margin-bottom: 1rem;

      /* Query container for the slide's fluid type. This has to live on the
         item rather than on .slide itself: cqw resolves against the nearest
         ANCESTOR container, so a container using its own cqw silently falls
         back to the viewport. */
      container-type: inline-size;

      ${breakpoint.TABLET} {
        min-width: 440px;
      }
    }
  }

  .slide {
    padding: 3rem;
    border-radius: 1rem;
    background: var(--colors-art-tan);
    box-shadow: 0px 2px 8px 0px rgba(47, 47, 82, 0.16);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    /*
     * Text scales with the card, not the viewport. Every font-size below is an
     * em multiple of this one value, so the slides keep their current internal
     * proportions and there is a single number to tune per breakpoint.
     * cqw here is 1% of the carousel item's content box (see the li above).
     * --slide-type-scale trims the whole card's type at once; 1 is the
     * unscaled baseline that matched the original fixed sizes.
     */
    --slide-type-scale: 0.85;

    font-size: calc(clamp(0.75rem, 4cqw, 1.125rem) * var(--slide-type-scale));

    ${breakpoint.TABLET} {
      font-size: calc(clamp(1rem, 6.25cqw, 1.75rem) * var(--slide-type-scale));
    }

    &.quote {
      hanging-punctuation: first;
    }

    &.slide1 {
      background: #bfcdff;
      p {
        color: var(--colors-art-darkgreen);
        &.quote-name {
          color: var(--colors-art-blue);
        }
      }
    }

    &.slide2 {
      background: var(--colors-alex-ink);
      p {
        color: var(--colors-art-tan);
        &.quote-name {
          color: var(--colors-art-lightyellow);
        }
      }
    }

    &.slide3 {
      background: #036a91;
      p {
        color: #e0e0e5;
      }
      .big {
        color: white;
      }
    }

    &.slide6 {
      background: #ede8cc;
      p {
        color: var(--colors-art-darkgreen);
        &.quote-name {
          color: var(--colors-art-blue);
        }
      }
    }

    &.slide5 {
      background: #1f3c3a;
      p {
        color: var(--colors-art-lightyellow);
      }
      .big {
        color: var(--colors-art-tan);
      }
    }

    &.slide7 {
      background: #e94210;
      p {
        color: #e0e0e5;
      }
      .big {
        color: white;
      }
    }

    &.slide4 {
      background: var(--colors-art-tan);
      p {
        color: var(--colors-art-darkgreen);
        &.quote-name {
          color: var(--colors-art-blue);
        }
      }
    }

    &.stat {
      /* font-size intentionally omitted: this is the same element as .slide,
         so it inherits the fluid scale above. Setting it here would resolve
         em against the parent and break the scale. */
      font-weight: 300;

      .big {
        font-family: 'Gelica', Georgia, serif;
        font-size: 2.5em;
        display: block;
        margin: 0;
        line-height: 1;

        ${breakpoint.TABLET} {
          font-size: 2.6667em;
        }
      }
    }

    &.quote {
      p {
        font-size: 1em;
        font-weight: 300;
        &:first-child {
          font-family: 'Gelica', Georgia, serif;
          font-size: 1.5em;
          font-weight: 400;
          margin-bottom: 1em;
          line-height: 1.3;

          ${breakpoint.TABLET} {
            font-size: 1.3333em;
            margin-bottom: 0.75em;
          }

          &:before {
            content: '“';
            position: absolute;
            margin-left: -0.4em;
          }
        }
      }
    }
  }
`;
